import React, {useState} from 'react';
import {Button, Container, Form} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {TermsAndConditions} from "../../../TermsAndConditions";

export const DomainCheckerForm = ({domain, setDomain, fetchDmarcRecord, loading}) => {
    const {t} = useTranslation();
    const [agreed, setAgreed] = useState(false);

    return (
        <section className="pb-5 bg-light">
            <Container className="d-flex justify-content-center">
                <Form
                    onSubmit={fetchDmarcRecord}
                    className="bg-white p-4 p-md-5 shadow rounded-3 w-100"
                    style={{maxWidth: 720}}
                >
                    <Form.Label htmlFor="domain">
                        {t('pages.dmarcChecker.lookup.form.title')}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        id="domain"
                        placeholder="e.g. example.com"
                        className="my-2"
                        required
                        value={domain}
                        onChange={(e) => setDomain(e.target.value)}
                        disabled={loading || !agreed}
                    />

                    <div className="d-flex justify-content-between mt-3">
                        <TermsAndConditions checked={agreed}
                                            onChange={(e) => setAgreed(e.target.checked)}></TermsAndConditions>
                        <Button
                            type="submit"
                            variant="primary"
                            disabled={loading}
                            className={"text-white"}
                        >
                            {loading
                                ? t('pages.dmarcChecker.lookup.form.checking')
                                : t('pages.dmarcChecker.lookup.form.check')}
                        </Button>
                    </div>
                </Form>
            </Container>
        </section>
    );
};
